<template>
	<div>
		<router-view :key="$route.meta.timestamp" />
	</div>
	<v-overlay
		v-model="isOverlayDisplayed"
		class="d-flex justify-content-center align-items-center">
		<div class="d-flex flex-column align-items-center">
			<v-progress-circular
				color="primary"
				indeterminate
				:size="100"
				:width="6"></v-progress-circular>
			<div
				v-if="overlayMessage"
				class="mt-4 text-subtitle-1 text-center overlay-status-message">
				{{ overlayMessage }}
			</div>
		</div>
	</v-overlay>
</template>
<script lang="js">
import { mapGetters } from "vuex";
import emitter from "@/utils/emitter";

export default {
	name: "App",
	data() {
		return {
			isOverlayDisplayed: false,
			overlayMessage: "",
		};
	},
	async mounted() {
		emitter.on("trigger-overlay", () => {
			this.isOverlayDisplayed = !this.isOverlayDisplayed;
			if (!this.isOverlayDisplayed) this.overlayMessage = "";
		});
		emitter.on("show-overlay", message => {
			this.overlayMessage = message || "";
			this.isOverlayDisplayed = true;
		});
		emitter.on("hide-overlay", () => {
			this.isOverlayDisplayed = false;
			this.overlayMessage = "";
		});
	},
	unmounted() {
		emitter.off("trigger-overlay");
		emitter.off("show-overlay");
		emitter.off("hide-overlay");
	},
	computed: {
		...mapGetters(["userPermissions"]),
	},
};
</script>
<style>
#app {
	--bs-bg-opacity: 1;
	background-color: rgba(
		var(--bs-light-rgb),
		var(--bs-bg-opacity)
	) !important;
}

.v-container {
	max-width: 100% !important;
}

.overlay-status-message {
	color: #fff;
	background: rgba(0, 0, 0, 0.55);
	padding: 8px 14px;
	border-radius: 8px;
	font-weight: 600;
	letter-spacing: 0.2px;
}
</style>
